/*
  Variant image filter

  När användaren klickar en color-swatch på produktsidan filtreras media-gallery
  att bara visa bilder för vald färg. Använder alt-text-pattern från import-
  pipelinen: "{produktnamn} - {färg} - {vy}".

  Funkar för båda brands:
  - Deerhunter: "Eagle Jacket - Olive Night - framifrån"
  - Chevalier: "Tweed Blazer - Olive Night - 1"

  Logik:
  - Lyssnar på PUB_SUB_EVENTS.variantChange
  - Plockar färgen från variant.featured_image.alt (split " - "[1])
  - Iterar .product__media-item, jämför img.alt och show/hide
  - Media-items utan färg i alt-texten visas alltid (delade bilder)
  - Produkter utan färg-varianter påverkas inte (event har ingen featured_image-alt)
*/

(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
    return;
  }

  function getColorFromAlt(alt) {
    if (!alt) return null;
    const parts = alt.split(' - ');
    if (parts.length < 2) return null;
    return (parts[1] || '').trim();
  }

  function filterGallery(sectionId, color) {
    if (!color) return;

    const gallery = document.querySelector(`media-gallery[id="MediaGallery-${sectionId}"]`);
    if (!gallery) return;

    const mediaItems = gallery.querySelectorAll('.product__media-item');
    mediaItems.forEach((item) => {
      const img = item.querySelector('img');
      if (!img) {
        // Non-image media (video, 3d) - alltid synlig
        item.style.display = '';
        return;
      }

      const itemColor = getColorFromAlt(img.alt);

      // Visa om: matchar färg, eller om bilden saknar färg-info (delad bild)
      const matches = !itemColor || itemColor === color;
      item.style.display = matches ? '' : 'none';
    });

    refreshSlider(sectionId);
  }

  // Dawn:s mobil-slider (SliderComponent) cachar slide-positioner vid init och
  // räknar bara om via ResizeObserver på slider-containern - vars storlek inte
  // ändras när vi display:none:ar enskilda slides. Resultat: räknaren visar rätt
  // antal men swipe-positionerna är felräknade (kan inte bläddra). resetPages()
  // re-queryar slides + kör initPages() som filtrerar på clientWidth > 0 (synliga).
  // Nollställer scroll så vyn börjar på första synliga slide (giltig position).
  function refreshSlider(sectionId) {
    const sliderComponent = document.getElementById('GalleryViewer-' + sectionId);
    if (!sliderComponent || typeof sliderComponent.resetPages !== 'function') return;

    sliderComponent.resetPages();
    const track = sliderComponent.querySelector('#Slider-Gallery-' + sectionId);
    if (track) track.scrollLeft = 0;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event && event.data && event.data.variant;
    if (!variant || !variant.featured_image) return;

    const color = getColorFromAlt(variant.featured_image.alt);
    if (!color) return;

    filterGallery(event.data.sectionId, color);
  });

  // Initial filtering vid page-load: variantChange-event triggas inte automatiskt
  // för ?variant=ID URL:er. Plocka selected variant från media-gallery via active-
  // media-item och filtrera baserat på dess alt-text.
  function applyInitialFilter() {
    const galleries = document.querySelectorAll('media-gallery');
    galleries.forEach((gallery) => {
      // Plocka section-id från gallery-id "MediaGallery-{sectionId}"
      const idMatch = gallery.id.match(/^MediaGallery-(.+)$/);
      if (!idMatch) return;
      const sectionId = idMatch[1];

      // Hitta "active" media-item (den som matchar selected variant) - har class
      // "is-active" eller liknande i Dawn. Fallback: första media-item.
      const activeItem = gallery.querySelector('.product__media-item.is-active')
                      || gallery.querySelector('[data-active="true"]')
                      || gallery.querySelector('.product__media-item');
      if (!activeItem) return;

      const img = activeItem.querySelector('img');
      if (!img) return;

      const color = getColorFromAlt(img.alt);
      if (!color) return;

      filterGallery(sectionId, color);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyInitialFilter);
  } else {
    applyInitialFilter();
  }
})();
